import api from '@/services/api'
import axios from 'axios'
import { WE_CHANNEL, WE_APP_ID, APP_SECRET } from '@/config'
import { base64Encode, randNumber, buildUrl } from '@/utils'
import md5 from 'md5'

const SERVER = {
  captchaInfoUrl: '/captchaInfo',
  rechargeUrl: '/auth/recharge',
  sendcodyUrl: '/auth/verify_code',
  loginUrl: '/auth/recharge',
  pretopupUrl: '/pay/pre_recharge', // 去付款
  topupWindowUrl: '/pay/recharge', // get请求，由后台重定向到银联
  payResultUrl: '/pay/recharge/query_result', // 查询支付结果get
  bannerUrl: '/official/booth/list',
  bannerDetailUrl: '/official/booth/detail',
  registerUrl: '/official/register',
  newRegisterUrl: '/official/appointment/register'
}

// 获取短信验证码
export function sendcody (params) {
  return api.post(SERVER.sendcodyUrl, params).then(res => {
    return res
  })
}

// 验证码认证
export function login (params) {
  return api.post(SERVER.loginUrl, params).then(res => {
    return res
  })
}

// 预付款确认金额
export function pretopup (params) {
  return api.post(SERVER.pretopupUrl, params).then(res => {
    return res
  })
}

// get请求，由后台重定向到银联
export function topupWindow (window, params) {
  window.location = buildUrl(process.env.VUE_APP_API_URL + SERVER.topupWindowUrl, params)
}

// 查询支付结果get
export function payResult (params) {
  return api.get(SERVER.payResultUrl, { params }).then(res => {
    return res
  })
}

// 首页轮播图
export function fetchBanner (params) {
  return api.get(SERVER.bannerUrl, { params }).then(res => {
    return res
  })
}

// 轮播图详情
export function getBannerDetail (params) {
  return api.get(SERVER.bannerDetailUrl, { params }).then(res => {
    return res
  })
}

// 体验用户注册
export function register (params) {
  return api.post(SERVER.registerUrl, params).then(res => {
    return res
  })
}
// 预约专业顾问回访
export function newRegister (params) {
  const trace_id = new Date().getTime() + randNumber(8)
  const token = md5(WE_APP_ID + trace_id + base64Encode(JSON.stringify(params)) + APP_SECRET)
  return api.post(SERVER.newRegisterUrl, params, {
    headers: {
      'Content-Type': 'application/json',
      'WE-APP-ID': WE_APP_ID,
      'WE-TRACE-ID': trace_id,
      'WE-CHANNEL': WE_CHANNEL,
      'WE-TOKEN': token
    }
  }).then(res => {
    return res.data;
  });
}

export function getAreaJson () {
  return axios.get('//fe-cdn.mofaxiao.com/assess/json/area.json').then(res => {
    return res
  })
}

export default {
  sendcody,
  login,
  pretopup,
  topupWindow,
  payResult,
  fetchBanner,
  getBannerDetail,
  register,
  newRegister,
  getAreaJson
}
